<template>
  <div class="calciatore-comparison" v-if="id_calciatore">
    {{ nomeCalciatore }} - 
    {{ preNomeSquadra }} ({{ prePrezzo }}) -
    {{ postNomeSquadra }} ({{ postPrezzo }})
  </div>
</template>

<script>
import mixins from "../../js/mixins";
import Vuex from "vuex";

export default {
  name: "calciatore-comparison",
  mixins: [mixins],
  props: {
    id_calciatore: {
      type: [Number, String],
      required: true,
      default: null,
    },
    pre: {
      type: Object,
      required: false,
      default: null,
    },
    post: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    preNomeSquadra() {
      return this.pre && this.asta_squadre[this.pre.squadra_id]
        ? this.asta_squadre[this.pre.squadra_id].name
        : "";
    },
    postNomeSquadra() {
      return this.post && this.asta_squadre[this.post.squadra_id]
        ? this.asta_squadre[this.post.squadra_id].name
        : "";
    },
    prePrezzo() {
      return this.pre
        ? this.pre.p
        : "";
    },
    postPrezzo() {
      return this.post
        ? this.post.p
        : "";
    },
    nomeCalciatore() {
      return this.calciatori[this.id_calciatore]
        ? this.calciatori[this.id_calciatore].calciatore
        : "";
    },
    ...Vuex.mapGetters(["calciatori", "asta_squadre"]),
  },
};
</script>
<style lang="scss" scoped>
</style>
